import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { hasTag } from '../../util/tag-utils';
import { EditCommunicationComponent } from '../edit-communication/edit-communication.component';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { AirportService } from '../../airport/airport.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var CommunicationComponent = /** @class */ (function () {
    function CommunicationComponent(_editCommunicationsDialog, _toggleService, snackBar, _airportService, _businessManagerService) {
        this._editCommunicationsDialog = _editCommunicationsDialog;
        this._toggleService = _toggleService;
        this.snackBar = snackBar;
        this._airportService = _airportService;
        this._businessManagerService = _businessManagerService;
        this.businessChange = new EventEmitter();
        this.hasTag = hasTag;
        this.editModeSet = false;
        this.ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        this.isRegionalManager = false;
    }
    CommunicationComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 1:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 2:
                        _b = !(_c.sent());
                        _c.label = 3;
                    case 3:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    CommunicationComponent.prototype.openEditCommunicationsDialog = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.business
        };
        dialogConfig.width = '500px';
        var dialogRef = this._editCommunicationsDialog.open(EditCommunicationComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 1:
                        _a.business = _b.sent();
                        this.businessChange.emit(this.business);
                        if (!isUpdated) {
                            return [2 /*return*/];
                        } // required to handle backdrop click.
                        if (isUpdated.cancelBtnClicked) {
                            return [2 /*return*/];
                        }
                        // isUpdated.success will be false if there is an error during any of the api calls.
                        if (!isUpdated.success) {
                            this.snackBar.open(this.ERROR_MSG, 'Error', {
                                duration: 6000
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return CommunicationComponent;
}());
export { CommunicationComponent };
